<template>
	<b-modal
		header-class="header-class-modal-doc-package"
		:title="selectedRows.length > 1 ? FormMSG(1, 'Reject these invoices') : FormMSG(2, 'Reject this invoice')"
		class="modal-danger"
		v-model="showModal"
		no-close-on-backdrop
		no-close-on-esc
		hide-header-close
	>
		<b-form-group :label="FormMSG(3, 'Enter your comment:')" label-for="comment">
			<b-form-textarea id="comment" ref="rejectComment" v-model="rejectComment" rows="3" />
		</b-form-group>
		<template #modal-footer>
			<div class="w-100 d-flex flex-row justify-content-end align-items-center">
				<b-button size="sm" variant="custom-outline-gray" class="w-138-px" block @click="closeModal">
					{{ FormMSG(4, 'Close') }}
				</b-button>
				<b-button
					:disabled="rejectComment.length < 3 || isSaving"
					size="sm"
					variant="custom-primary-blue"
					class="w-138-px ml-2"
					style="margin-top: -1px"
					@click="finaliseInvoiceReject"
					block
				>
					<div class="d-flex justify-content-center align-items-center" style="gap: 7px">
						<b-spinner v-show="isSaving" small></b-spinner>
						<div class="pl-2" style="margin-top: 1px">{{ FormMSG(5, 'Save') }}</div>
					</div>
				</b-button>
			</div>
		</template>
	</b-modal>
</template>

<script>
import { rejectExpenses } from '@/cruds/expense.crud';
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';

export default {
	name: 'DialogRejectInvoice',
	mixins: [languageMessages, globalMixin],
	props: {
		selectedRows: {
			type: Array,
			default: () => []
		},
		showModal: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			rejectComment: '',
			isSaving: false
		};
	},
	methods: {
		async finaliseInvoiceReject() {
			this.isSaving = true;
			const ids = this.selectedRows.map((item) => parseInt(item.id));
			const comment = this.rejectComment;
			try {
				const record = await rejectExpenses(ids, comment);
				this.isSaving = false;
				this.$emit('reject', record);
			} catch (error) {
				console.log(error);
				this.createToastForMobile(this.FormMSG(6, 'Error'), this.FormMSG(7, 'Error occurred when trying to reject the invoice'), '', 'danger');
				this.isSaving = false;
			}
		},
		closeModal() {
			this.$emit('close');
		}
	},
	watch: {
		showModal(newValue) {
			if (newValue) {
				this.$nextTick(() => {
					this.rejectComment = '';
					this.$refs.rejectComment.focus();
				});
			}
		}
	}
};
</script>
